import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative bg-navy text-cream pt-20 pb-24 px-6 overflow-hidden" data-id="element-115">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold via-navy to-navy" data-id="element-116"></div>

      <div className="max-w-5xl mx-auto relative z-10 flex flex-col lg:flex-row items-center gap-12" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex-1 text-center lg:text-left" data-id="element-118">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 text-cream" data-id="element-119">
            Cuna de Hierro: El Protocolo de Transferencia Táctica para Dormir a
            tu Bebé en <span className="text-gold italic" data-id="element-120">&lt;10 Minutos</span>
          </h1>
          <h2 className="text-xl md:text-2xl text-cream/80 font-light mb-10 leading-relaxed" data-id="element-121">
            Recupera tus noches y tu cordura con el método de "traspaso
            invisible" que no requiere dejar a tu bebé llorando solo.
          </h2>

          <div className="flex justify-center lg:justify-start" data-id="element-122">
            <Button href="#comprar" data-id="element-123">¡QUIERO RECUPERAR MIS NOCHES AHORA!</Button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-124">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-gold/20" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/8GuNnKheYk96ufBrGQXEB3/CUNA_DE_HIERRO.png" alt="Cuna de Hierro - Protocolo de Transferencia Táctica" className="w-full h-auto object-cover" data-id="element-126" />
          </div>
        </motion.div>
      </div>
    </section>;
}